import { Controller } from 'stimulus';

export default class ImagePreview extends Controller {
  static targets = ["logo"]

  initialize() {
    const url = this.logoTarget.dataset.url
    const filename = this.logoTarget.dataset.filename

    if ( url === undefined || filename === undefined ) { return; }
    if ( url.length > 0 && filename.length > 0 ) {
      let style = this.logoTarget.querySelector(".wrapped-file-preview").style;

      style.backgroundImage = `url("${url}")`;
      style.backgroundPosition = "center";
      style.backgroundSize = "cover";

      this.logoTarget.querySelector(".wrapped-file-label").textContent = filename
    }
  }

  connect() {
    const input = this.logoTarget.querySelector('input[type="file"]');
    if (!input) { return; }

    this._handleFileChange = this._handleFileChange.bind(this);
    input.addEventListener('change', this._handleFileChange);
  }

  disconnect() {
    const input = this.logoTarget.querySelector('input[type="file"]');
    if (!input || !this._handleFileChange) { return; }

    input.removeEventListener('change', this._handleFileChange);
  }

  _handleFileChange(event) {
    const input = event.target;

    const MAX_BYTES = 10 * 1024 * 1024; // 10MB
    const MAX_WIDTH = 3000;
    const MAX_HEIGHT = 3000;
    const file = input.files && input.files[0];
    const wrapper = input.closest('.input') || input.parentElement;

    if (!wrapper) { return; }

    const findErrorEl = () => wrapper.querySelector('div.inline-errors');

    const clearError = () => {
      const errorEl = findErrorEl();
      if (errorEl) { errorEl.textContent = ''; }
    };

    clearError();

    if (!file) { return; }

    // Validate file size
    if (file.size > MAX_BYTES) {
      let errorEl = findErrorEl();
      if (!errorEl) {
        errorEl = document.createElement('div');
        errorEl.className = 'inline-errors text-xs text-red-500 mt-2';
        wrapper.appendChild(errorEl);
      }

      errorEl.textContent = 'Please choose an image under 10 MB.';
      input.value = '';
      return;
    }

    // Validate image dimensions (max 3000 x 3000)
    const reader = new FileReader();
    const img = new Image();

    reader.onload = function(e) {
      img.onload = function() {
        if (img.width > MAX_WIDTH || img.height > MAX_HEIGHT) {
          let errorEl = findErrorEl();
          if (!errorEl) {
            errorEl = document.createElement('div');
            errorEl.className = 'inline-errors text-xs text-red-500 mt-2';
            wrapper.appendChild(errorEl);
          }

          errorEl.textContent = 'Max 3000 x 3000 px.';
          input.value = '';
        } else {
          clearError();
        }
      };

      img.src = e.target.result;
    };

    reader.readAsDataURL(file);
  }
}
